import { PiFolder, PiGridFourDuotone, PiNewspaperClippingDuotone } from "react-icons/pi";
import { HeaderMenuItem } from "../type/menu-type";

export const menuRoutes = {
    auth: {
        login: "/login",
        forgot_password: "/forgot-password",
        reset_password: "/reset-password",
    },
    contract_public: {
        find: "/find-contract",
        sign: "/sign-contract/:hash",
        error: "/find-contract/not-found",
        signed: "/signed-contract/:id"
    },
    direct_debit_mandate: {
        find: "/find-direct-debit-mandate",
        sign: "/sign-direct-debit-mandate/:hash",
        error: "/find-direct-debit-mandate/not-found",
        signed: "/signed-direct-debit-mandate/:id"
    },
    tutor_agreement: {
        sign: "/sign-tutor-agreement/:hash",
        error: "/sign-tutor-agreement/not-found",
        signed: "/signed-tutor-agreement"
    },
    dashboard: {
        path: "/dashboard",
    },
    organisations: {
        path: "/organisations",
        create: "create",
        edit: ":id/edit",
    },
    roles: {
        path: "/roles",
        create: "create",
        edit: ":id/edit",
    },
    users: {
        path: "/users",
        create: "create",
        edit: ":id/edit/info",
        edit_permissions: ":id/edit/permissions",
        profile: {
            path: ":id/profile",
            info: "/info",
            stats: "/stats",
            scores: "/scores",
            rankings: "/user-rankings",
            documents: "/documents",
            permissions: "/permissions",
            contract_history: "/contract-history",
            activity: "/activity",
            calls: "/calls"
        },
    },
    products: {
        path: "/products",
        create: "create",
        edit: ":id/edit",
        inspectorCredentials: "/inspector-credentials",
        subsidisedActions: "/acciones-bonificadas",
    },
    states: {
        path: "/states",
        create: ":entity/create",
        edit: ":id/edit",
        koReasons: "/ko-reasons",
        list: {
            contract: "/contract_states",
            contract_product: "/contract_product_states",
            contract_invoicing: "/contract_invoicing_states",
            contract_incidence: "/contract_incidence_states",
            contract_blocked: "/contract_blocked_states",
            contract_commission: "/contract_commission_states",
            invoice: "/invoice_states",
            expiration: "/expiration_states",
            expiration_management: "/expiration_management_states",
            incidence: "/incidence_states",
            renovation: "/renovation_states",
            order: "/order_states",
            lead: "/lead_states",
        }
    },
    corporations: {
        path: "/corporations",
        create: "create",
        edit: ":id/edit",
        detail: "detail/:id",
    },
    tutors: {
        path: "/tutors",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            stats: "/stats",
            documents: "/documents",
            invoices: "/invoices",
            contracts: "/contracts",
        },
    },
    invoices: {
        path: "/invoices",
        create: "create",
        nonStandard: "create/non-standard",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            activityHistory: "/activity-history",
            expirations: "/expirations",
        },
    },
    expirations: {
        path: "/expirations",
        create: "create",
        edit: ":id/edit",
    },
    leads: {
        path: "/leads",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            statusHistory: "/status-history",
            comments: "/comments",
        },
    },
    tutor_panel: {
        tutorials: "/my-tutorials",
        invoices: "/my-invoices",
        calendar: "/my-calendar",
        documents: "/my-documents",
        profile: "/my-profile",
        login: "/tutor-login",
        forgot_password: "/tutor-forgot-password",
        reset_password: "/tutor-reset-password",
    },
    networks: {
        path: "/networks",
        create: "create",
        edit: ":id/edit",
        detail: "detail/:id",
        settlements: "/settlements",
        settlementDetail: "/settlements/:commercialNetworkId",
    },
    departments: {
        path: "/departments",
        create: "create",
        edit: ":id/edit",
        detail: "detail/:id",
    },
    clients: {
        path: "/clients",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            students: "/students",
            products: "/products",
            contracts: "/contracts",
            consultancy: "/consultancy",
            invoices: "/invoices",
            calls: "/calls",
            comments: "/comments",
            creditHistory: "/credit-history",
            activityHistory: "/activity-history",
            commercialNetworks: "/commercial-networks",
        },
    },
    students: {
        path: "/students",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            activityHistory: "/activity-history",
        },
    },
    consultancies: {
        path: "/consultancies",
        create: "create",
        edit: ":id/edit",
    },
    generalConfiguration: {
        path: "/general-configuration",
        professionalCategories: "/professional_categories",
        quotationGroups: "/quotation_groups",
        educationalLevels: "/studies",
        campaigns: "/campaigns",
        trainingActionGroups: "/training-action-groups",
        professionalAreas: "/professional-areas",
        trainingModalities: "/training-modalities",
    },
    contracts: {
        path: "/contracts",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            invoicing: "/invoicing",
            calls: "/calls",
            documents: "/documents",
            incidences: "/incidences",
            statesHistory: "/states-history",
            changelogs: "/changelogs",
            comments: "/comments",
            scoresHistory: "/scores-history",
            tracking: "/tracking",
            extras: "/extras",
        }
    },
    settings: {
        path: "/settings",
        orders: "/orders",
        invoices: "/invoices",
        contracts: "/contracts",
        tutors: "/tutors",
        holidays: "/holidays",
        templates: "/templates",
        events: "/events",
        rankings: "/rankings",
        document_types: "/document-types",
        product_types: "/product-types",
        fundae_groupings: "/fundae-groupings",
        commissions: "/commissions",
    },
    userRankings: {
        path: "/user-rankings",
        profile: ":id/info",
    },
    calls: {
        path: "/calls",
        list: "/list",
        total: "/total",
        classifications: "/classifications",
        callClassifications: "/call-classifications",
        communications: "/communications",
        communicationDetail: "/communications/:id",
        assignments: "/assignments",
        pendingExtras: "/pending-extras",
        scheduled: "/scheduled",
        platformAdvances: "/platform-advances",
        profile: {
            path: ":id/profile",
            info: "/info",
            records: "/records",
        },
    },
    rankings: {
        path: "/rankings",
    },
    incidences: {
        path: "/incidences",
        tutor: "/tutor",
        blockedContracts: "/blocked-contracts",
        create: "create/:contractId?",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            comments: "/comments",
            documents: "/documents",
            statesHistory: "/states-history",
        }
    },
    incidenceTypes: {
        path: "/incidence-types",
        create: "create",
        edit: ":id/edit"
    },
    orders: {
        path: "/orders",
        list: "/list",
        calendar: "/calendar",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile",
            info: "/info",
            stats: "/stats",
            contracts: "/contracts",
            campaigns: "/campaigns",
            groupCodes: "/group-codes",
            assignments: "/assignments",
            exports: "/exports",
            xmlHistory: "/xml-history",
        }
    },
    orderTypes: {
        path: "/order-types",
        create: "create",
        edit: ":id/edit"
    },
    remittances: {
        path: "/remittances",
        create: "create",
        edit: ":id/edit",
    },
};

const invoiceListHref = (filterFilters: Record<string, any>) => {
    return `${menuRoutes.invoices.path}?filter_filters=${encodeURIComponent(JSON.stringify(filterFilters))}&limit=50&page=1`;
};

const internalInvoiceTypes = ['internal_invoice', 'providing', 'platform'];

export const attivaMenuItems: HeaderMenuItem = {
    dashboardMenu: {
        id: "dashboard",
        name: "Inicio",
        path: "/dashboard",
        type: "enhance",
        facilitator_access: ['facilitator', 'facilitator_manager'],
        permissions_any_of: [
            {
                group: "dashboard",
                action: "get_dashboard_information",
            },
            {
                group: "dashboard",
                action: "show_complete_dashboard",
            }
        ],
    },
    contractsMenu: {
        id: "contracts",
        name: "Contratos",
        path: menuRoutes.contracts.path,
        icon: "DocumentIcon",
        react_icon: PiFolder,
        type: "link",
        permissions_required: [
            {
                group: "contracts",
                action: "admin_contracts",
            }
        ],
    },
    ordersMenu: {
        id: "orders",
        name: "Pedidos",
        path: menuRoutes.orders.path + menuRoutes.orders.list,
        icon: "DeliveryTruckIcon",
        react_icon: PiFolder,
        type: "link",
        permissions_required: [
            {
                group: "orders",
                action: "admin_orders",
            }
        ],
    },
    salesMenu: {
        id: "sales",
        name: "Ventas",
        path: "/sales",
        react_icon: PiFolder,
        type: "enhance",
        dropdownItems: [
            {
                id: "clients",
                name: "Gestión de clientes",
                path: "",
                icon: "UserLockIcon",
                subMenuItems: [
                    {
                        name: "Clientes",
                        href: menuRoutes.clients.path,
                        permissions_required: [
                            {
                                group: "clients",
                                action: "admin_clients",
                            }
                        ],
                    },
                    {
                        name: "Empleados",
                        href: menuRoutes.students.path,
                        permissions_required: [
                            {
                                group: "students",
                                action: "admin_students",
                            }
                        ],
                    },
                    {
                        name: "Asesorías",
                        href: menuRoutes.consultancies.path,
                        permissions_required: [
                            {
                                group: "consultancies",
                                action: "admin_consultancies",
                            }
                        ],
                    },
                ]
            },
            {
                id: "contracts",
                name: "Gestión de contratos",
                icon: "DocumentIcon",
                subMenuItems: [
                    {
                        name: 'Contratos',
                        href: menuRoutes.contracts.path,
                        permissions_required: [{
                            group: 'contracts',
                            action: 'admin_contracts',
                        }],
                    },
                    {
                        name: "Vencimientos",
                        href: menuRoutes.expirations.path,
                        icon: "PointOfSellIcon",
                        permissions_required: [
                            {
                                group: "expirations",
                                action: "admin_expirations",
                            }
                        ],
                    },
                    {
                        name: "Remesas",
                        href: menuRoutes.remittances.path,
                        icon: "PointOfSellIcon",
                        permissions_required: [
                            {
                                group: "expirations",
                                action: "generate_sepa",
                            }
                        ],
                    },
                    {
                        name: "Ranking de Usuarios",
                        href: menuRoutes.userRankings.path,
                        icon: "PointOfSellIcon",
                        permissions_required: [
                            {
                                group: "rankings",
                                action: "admin_rankings",
                            },
                            {
                                group: "rankings",
                                action: "list_rankings",
                            }
                        ],
                    },
                    {
                        name: "Rankings (Generales)",
                        href: menuRoutes.rankings.path,
                        icon: "PointOfSellIcon",
                        permissions_required: [
                            {
                                group: "rankings",
                                action: "admin_rankings",
                            },
                            {
                                group: "rankings",
                                action: "list_rankings",
                            }
                        ],
                    },
                    {
                        name: "Renovaciones (Leads)",
                        href: menuRoutes.leads.path,
                        icon: "PointOfSellIcon",
                        permissions_required: [
                            {
                                group: "leads",
                                action: "admin_leads",
                            }
                        ],
                    },
                ]
            },
            {
                id: "campaign-management",
                name: "Gestión de campañas",
                icon: "PointOfSellIcon",
                subMenuItems: [
                    {
                        name: "Llamadas totales",
                        href: menuRoutes.calls.path + menuRoutes.calls.total,
                        permissions_required: [
                            {
                                group: "calls",
                                action: "list_calls",
                            }
                        ],
                    },
                    {
                        name: "Tipos de seguimiento",
                        href: menuRoutes.calls.path + menuRoutes.calls.classifications,
                        permissions_required: [
                            {
                                group: "call_result_classifications",
                                action: "list_call_result_classifications",
                            }
                        ],
                    },
                    {
                        name: "Tipificaciones de llamadas",
                        href: menuRoutes.calls.path + menuRoutes.calls.callClassifications,
                        permissions_required: [
                            {
                                group: "call_classifications",
                                action: "list_call_classifications",
                            }
                        ],
                    },
                    {
                        name: "Comunicaciones",
                        href: menuRoutes.calls.path + menuRoutes.calls.communications,
                        permissions_required: [
                            {
                                group: "communications",
                                action: "list_communications",
                            }
                        ],
                    },
                    {
                        name: "Asignaciones dinamizador",
                        href: menuRoutes.calls.path + menuRoutes.calls.assignments,
                        permissions_required: [
                            {
                                group: "user",
                                action: "show_all_system_facilitators",
                            }
                        ],
                    },
                    {
                        name: "Agendados",
                        href: menuRoutes.calls.path + menuRoutes.calls.scheduled,
                        permissions_required: [
                            {
                                group: "contracts",
                                action: "show_contract_tracking",
                            }
                        ],
                    },
                    {
                        name: "Extras pendientes",
                        href: menuRoutes.calls.path + menuRoutes.calls.pendingExtras,
                        permissions_required: [
                            {
                                group: "contracts",
                                action: "show_all_pending_contract_extras",
                            }
                        ],
                    },
                    {
                        name: "Avances plataforma",
                        href: menuRoutes.calls.path + menuRoutes.calls.platformAdvances,
                        permissions_required: [
                            {
                                group: "platform_advances",
                                action: "list_platform_advances",
                            }
                        ],
                    },
                ],
            },
            {
                id: "invoice-management",
                name: "Gestión de facturas",
                icon: "PointOfSellIcon",
                subMenuItems: [
                    {
                        name: "Todas las facturas",
                        href: invoiceListHref({ is_rectification_invoice: false }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "admin_invoices",
                            }
                        ],
                    },
                    {
                        name: "Todas las rectificativas",
                        href: invoiceListHref({ is_rectification_invoice: true }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_rectification_invoices",
                            }
                        ],
                    },
                                        
                    {
                        name: "Facturas cliente",
                        href: invoiceListHref({ is_rectification_invoice: false, invoice_type: ['client_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_client_invoices",
                            }
                        ],
                    },
                    {
                        name: "Rectificativas cliente",
                        href: invoiceListHref({ is_rectification_invoice: true, invoice_type: ['client_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_rectification_invoices",
                            }
                        ],
                    },
                    {
                        name: "Facturas internas",
                        href: invoiceListHref({ is_rectification_invoice: false, invoice_type: ['internal_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_internal_invoices",
                            }
                        ],
                    },
                    {
                        name: "Rectificativas internas",
                        href: invoiceListHref({ is_rectification_invoice: true, invoice_type: ['internal_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_rectification_invoices",
                            }
                        ],
                    },
                    {
                        name: "Facturas impartidora",
                        href: invoiceListHref({ is_rectification_invoice: false, invoice_type: ['providing'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_internal_invoices",
                            }
                        ],
                    },
                    {
                        name: "Rectificativas impartidora",
                        href: invoiceListHref({ is_rectification_invoice: true, invoice_type: ['providing'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_internal_invoices",
                            }
                        ],
                    },
                    {
                        name: "Facturas plataforma",
                        href: invoiceListHref({ is_rectification_invoice: false, invoice_type: ['platform'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_internal_invoices",
                            }
                        ],
                    },
                    {
                        name: "Rectificativas plataforma",
                        href: invoiceListHref({ is_rectification_invoice: true, invoice_type: ['platform'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_internal_invoices",
                            }
                        ],
                    },
                    {
                        name: "Facturas atípicas",
                        href: invoiceListHref({ is_rectification_invoice: false, invoice_type: ['non_standard_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_non_standard_invoices",
                            }
                        ],
                    },
                    {
                        name: "Rectificativas atípicas",
                        href: invoiceListHref({ is_rectification_invoice: true, invoice_type: ['non_standard_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_rectification_invoices",
                            }
                        ],
                    },
                    {
                        name: "Facturas de tutor",
                        href: invoiceListHref({ is_rectification_invoice: false, invoice_type: ['tutor_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_tutor_invoices",
                            }
                        ],
                    },
                    {
                        name: "Rectificativas tutor",
                        href: invoiceListHref({ is_rectification_invoice: true, invoice_type: ['tutor_invoice'] }),
                        permissions_required: [
                            {
                                group: "invoices",
                                action: "show_rectification_invoices",
                            }
                        ],
                    },
                ]
            },
            {
                id: "incidences",
                name: "Gestión Incidencias",
                icon: "AlertCautionBulbIcon",
                subMenuItems: [
                    {
                        name: 'Incidencias',
                        href: menuRoutes.incidences.path,
                        permissions_required: [
                            {
                                group: 'incidences',
                                action: 'admin_incidences',
                            }
                        ],
                    },
                    {
                        name: 'Incidencias tutor',
                        href: menuRoutes.incidences.path + menuRoutes.incidences.tutor,
                        permissions_any_of: [
                            {
                                group: 'incidences',
                                action: 'show_user_tutor_incidences',
                            },
                            {
                                group: 'incidences',
                                action: 'show_all_tutor_incidences',
                            }
                        ],
                    },
                    {
                        name: 'Bloqueados',
                        href: menuRoutes.incidences.path + menuRoutes.incidences.blockedContracts,
                        permissions_required: [
                            {
                                group: 'contracts',
                                action: 'admin_contracts',
                            }
                        ],
                    },
                    {
                        name: "Tipos de Incidencias",
                        href: menuRoutes.incidenceTypes.path,
                        icon: "PointOfSellIcon",
                        permissions_required: [
                            {
                                group: 'incidence_types',
                                action: 'list_incidence_types',
                            },
                            {
                                group: 'incidence_types',
                                action: 'admin_incidence_types',
                            }
                        ],
                    },
                ]
            },
            {
                id: "orders",
                name: "Gestión de pedidos",
                icon: "DeliveryTruckIcon",
                subMenuItems: [
                    {
                        name: 'Listado de Pedidos',
                        href: menuRoutes.orders.path + menuRoutes.orders.list,
                        permissions_required: [
                            {
                                group: 'orders',
                                action: 'list_orders',
                            },
                            {
                                group: 'orders',
                                action: 'admin_orders',
                            }
                        ],
                    },
                    {
                        name: 'Calendario de Pedidos',
                        href: menuRoutes.orders.path + menuRoutes.orders.calendar,
                        permissions_required: [
                            {
                                group: 'orders',
                                action: 'list_orders',
                            },
                            {
                                group: 'orders',
                                action: 'admin_orders',
                            }
                        ],
                    },
                    {
                        name: "Tipos de Pedidos",
                        href: menuRoutes.orderTypes.path,
                        icon: "PointOfSellIcon",
                        permissions_required: [
                            {
                                group: 'order_types',
                                action: 'list_order_types',
                            },
                            {
                                group: 'order_types',
                                action: 'admin_order_types',
                            }
                        ],
                    },
                ]
            },
        ]
    },
    administrationMenu: {
        id: "administration",
        name: "Administración",
        path: "/admin",
        react_icon: PiFolder,
        type: "enhance",
        dropdownItems: [
            {
                id: "access-and-credentials",
                name: "Control de acceso",
                icon: "UserLockIcon",
                subMenuItems: [
                    {
                        name: "Usuarios",
                        href: menuRoutes.users.path,
                        //icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "user",
                                action: "admin_user",
                            }
                        ],
                    },
                    {
                        name: "Tutores",
                        href: menuRoutes.tutors.path,
                        //icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "tutors",
                                action: "admin_tutors",
                            }
                        ],
                    },
                    {
                        name: "Roles",
                        href: menuRoutes.roles.path,
                        icon: "RolesIcon",
                        permissions_required: [
                            {
                                group: "roles",
                                action: "admin_roles",
                            },
                        ],
                    },
                ]
            },
            {
                id: "states",
                name: "Gestión de estados",
                icon: "DocumentIcon",
                subMenuItems: [
                    {
                        name: 'Contrato',
                        href: menuRoutes.states.path + menuRoutes.states.list.contract,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Producto del contr.',
                        href: menuRoutes.states.path + menuRoutes.states.list.contract_product,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Facturación del contr.',
                        href: menuRoutes.states.path + menuRoutes.states.list.contract_invoicing,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Incidencia del contr.',
                        href: menuRoutes.states.path + menuRoutes.states.list.contract_incidence,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Bloqueado del contr.',
                        href: menuRoutes.states.path + menuRoutes.states.list.contract_blocked,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Comisión del contr.',
                        href: menuRoutes.states.path + menuRoutes.states.list.contract_commission,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Facturas',
                        href: menuRoutes.states.path + menuRoutes.states.list.invoice,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Vencimiento',
                        href: menuRoutes.states.path + menuRoutes.states.list.expiration,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Gestión vencimientos',
                        href: menuRoutes.states.path + menuRoutes.states.list.expiration_management,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Incidencia',
                        href: menuRoutes.states.path + menuRoutes.states.list.incidence,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Renovación',
                        href: menuRoutes.states.path + menuRoutes.states.list.renovation,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Pedido',
                        href: menuRoutes.states.path + menuRoutes.states.list.order,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                    {
                        name: 'Motivos de KO',
                        href: menuRoutes.states.path + menuRoutes.states.koReasons,
                        permissions_required: [{
                            group: 'statuses',
                            action: 'admin_statuses',
                        }],
                    },
                ]
            },
            {
                id: "products",
                name: "Gestión productos",
                icon: "PackageOpenIcon",
                subMenuItems: [
                    {
                        name: "Productos",
                        href: menuRoutes.products.path,
                        icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "products",
                                action: "admin_products",
                            }
                        ],
                    },
                    {
                        name: "Acciones bonificadas",
                        href: menuRoutes.products.path + menuRoutes.products.subsidisedActions,
                        icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "products",
                                action: "admin_products",
                            }
                        ],
                    },
                    {
                        name: "Cred. inspector",
                        href: menuRoutes.products.path + menuRoutes.products.inspectorCredentials,
                        icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "inspector_credentials",
                                action: "list_inspector_credentials",
                            }
                        ],
                    },
                ]
            },
            {
                id: "networks",
                name: "Estructura",
                path: "",
                icon: "StructureIcon",
                subMenuItems: [
                    {
                        name: "Empresas fiscales",
                        href: menuRoutes.corporations.path,
                        icon: "ApartmentIcon",
                        permissions_required: [
                            {
                                group: "corporation",
                                action: "admin_corporation",
                            }
                        ],
                    },
                    {
                        name: "Redes y deptos.",
                        href: menuRoutes.networks.path,
                        icon: "NetworksIcon",
                        permissions_required: [
                            {
                                group: "commercial_network",
                                action: "admin_commercial_network",
                            },
                            {
                                group: "departments",
                                action: "admin_departments",
                            }
                        ],
                    },
                    {
                        name: "Liquidaciones Red",
                        href: menuRoutes.networks.path + menuRoutes.networks.settlements,
                        icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "commercial_network",
                                action: "list_commercial_network",
                            }
                        ],
                    },
                ]
            },
            {
                id: "generalConfiguration",
                name: "Configuración",
                path: "",
                icon: "ConfigIcon",
                subMenuItems: [
                    {
                        name: "Cat. profesionales",
                        href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.professionalCategories,
                        permissions_required: [
                            {
                                group: "professional_categories",
                                action: "admin_professional_categories",
                            },
                            {
                                group: "professional_categories",
                                action: "list_professional_categories",
                            }
                        ],
                    },
                    {
                        name: "Grupos de cotización",
                        href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.quotationGroups,
                        permissions_required: [
                            {
                                group: "quotation_groups",
                                action: "admin_quotation_groups",
                            },
                            {
                                group: "quotation_groups",
                                action: "list_quotation_groups",
                            }
                        ],
                    },
                    {
                        name: "Niveles educativos",
                        href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.educationalLevels,
                        permissions_required: [
                            {
                                group: "studies",
                                action: "admin_studies",
                            },
                            {
                                group: "studies",
                                action: "list_studies",
                            }
                        ],
                    },
                    {
                        name: "Campañas",
                        href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.campaigns,
                        permissions_required: [
                            {
                                group: "campaigns",
                                action: "admin_campaigns",
                            },
                            {
                                group: "campaigns",
                                action: "list_campaigns",
                            }
                        ],
                    },
                    {
                        name: "Grupos formativos",
                        href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.trainingActionGroups,
                        permissions_required: [
                            {
                                group: "products",
                                action: "admin_products",
                            }
                        ],
                    },
                    {
                        name: "Áreas profesionales",
                        href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.professionalAreas,
                        permissions_required: [
                            {
                                group: "products",
                                action: "admin_products",
                            }
                        ],
                    },
                    {
                        name: "Modalidades",
                        href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.trainingModalities,
                        permissions_required: [
                            {
                                group: "products",
                                action: "admin_products",
                            }
                        ],
                    },
                ]
            },
        ]
    },
    superAdminMenu: {
        id: "title-super-admin",
        name: "Panel Administración",
        icon: "GreenLeafIcon",
        react_icon: PiFolder,
        type: "enhance",
        columns: "1",
        permissions_required: [
            {
                group: "companies",
                action: "admin_company",
            },
        ],
        dropdownItems: [
            {
                id: "organisations",
                name: "Organizaciones",
                path: menuRoutes.organisations.path,
                icon: "ApartmentIcon",
                react_icon: PiGridFourDuotone,
                permissions_required: [
                    {
                        group: "companies",
                        action: "admin_company",
                    },
                ],
                subMenuItems: [
                    {
                        name: "Organizaciones",
                        href: menuRoutes.organisations.path,
                        permissions_required: [
                            {
                                group: "companies",
                                action: "list_company",
                            }
                        ],
                    },
                ]
            },
            {
                id: "roles",
                name: "Roles",
                path: menuRoutes.roles.path,
                icon: "RolesIcon",
                react_icon: PiNewspaperClippingDuotone,
                permissions_required: [
                    {
                        group: "roles",
                        action: "admin_roles",
                    },
                ],
                subMenuItems: [
                    {
                        name: "Lista Roles",
                        href: menuRoutes.roles.path,
                        permissions_required: [
                            {
                                group: "roles",
                                action: "list_roles",
                            }
                        ],
                    },
                    {
                        name: "Crear Rol",
                        href: menuRoutes.roles.path + '/' + menuRoutes.roles.create,
                        permissions_required: [
                            {
                                group: "roles",
                                action: "create_roles",
                            }
                        ],
                    },
                ]
            },
        ],
    },
};

export const tutorMenuItems: HeaderMenuItem = {
    myTutorials: {
        id: "my-tutorials",
        name: "Tutorías",
        path: menuRoutes.tutor_panel.tutorials,
        type: "enhance",
    },
    myCalendar: {
        id: "my-calendar",
        name: "Calendario",
        path: menuRoutes.tutor_panel.calendar,
        type: "enhance",
    },
    myInvoices: {
        id: "my-invoices",
        name: "Facturas",
        path: menuRoutes.tutor_panel.invoices,
        type: "enhance",
    },
    myDocuments: {
        id: "my-documents",
        name: "Documentos",
        path: menuRoutes.tutor_panel.documents,
        type: "enhance",
    },
    myProfile: {
        id: "my-profile",
        name: "Mi perfil",
        path: menuRoutes.tutor_panel.profile,
        type: "enhance",
    },
};
